import { NgModule,OnChanges } from '@angular/core';
import { Routes, RouterModule , Router, NavigationStart} from '@angular/router';

// Layouts
import { LogInComponent } from './Core/Login/login.component';
import { RoutingComponent } from './Core/Routes/routing.component';
import { ChangePasswordComponent } from './Core/Login/changePassword.component';
import { RegisterComponent } from './Core/Register/register.component';
import { ForgotPasswordComponent } from './Core/Login/forgotPassword.component';
import { ConfirmComponent } from './Core/Register/confirm.component';
import { RejectComponent } from './Core/Register/reject.component';
import { ContactUsComponent } from './Menus/Onboard/ContactUs/contactUs.component';
import { ResetPasswordComponent } from './Core/Login/resetPassword.component';
import { OnBoardedComponent } from './Menus/Onboard/Onboarded/onboarded.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'menu/home',    
    pathMatch: 'full'
  },
  // DbLogin (default)
  {
    path: 'changePassword',
    component : ChangePasswordComponent
  }, 
  {
    path: 'forgotPassword',
    component : ForgotPasswordComponent
  }, 
  {
    path: 'resetPassword',
    component : ResetPasswordComponent
  }, 
  {
    path: 'login',
    component : LogInComponent
  },
  {
    path: 'register',
    component : RegisterComponent
  },
  {
    path: 'reject',
    component : RejectComponent
  },
  {
    path: 'confirm',
    component : ConfirmComponent
  },
  {
    path: 'contact',
    component : ContactUsComponent
  },
  {
    path: 'onboarded',
    component: OnBoardedComponent
  },
  { path: '**', component: RoutingComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule{

}
